import {
  //document
  DELETE_DOCUMENT,
  DOCS_UPLOADED_OR_EVERIFIED_SUCCESS,
  E_VERIFY_SUCCESS,
  INSERT_USER_DOCUMENT,
  GET_UPLOAD_DOCUMENTS_CONFIG,
  UPDATE_UPLOAD_DOCUMENTS_CONFIG,
  UPDATE_VISION_CHECK_COUNT,
  UPLOAD_DOC_SUCCESS,
  UPLOAD_PHOTO_SUCCESS,
  USER_DOCUMENTS_INFO,
  DESTROY_DOCUMENT_DATA,
  EMP_TYPE_PASS,
  DISABLE_PERSONAL_DETAILS_FILEDS
} from '../../action-contants';
import { mergeObjectArray } from '../../../utils/library';

const INITIAL_STATE = {
  isDocsUploadedOrEVerifiedSuccess: false,
  visionCheckCount: 0,
  eVerifyData: [],
  uploadDocConfig: [],
  documentDetails: [],
  empPass: [],
  paymentMethod: {}
};

export default function documentDataReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case DESTROY_DOCUMENT_DATA: {
      return INITIAL_STATE;
    }
    case DELETE_DOCUMENT: {
      const documentDetails = [...state.documentDetails];
      //to find exact representative's documents
      documentDetails.forEach((key, index) => {
        if (
          key.entity_type === action.data.entity_type &&
          key.entity_id === action.data.entity_id
        ) {
          documentDetails.splice(index, 1);
        }
      });
      return { ...state, documentDetails };
    }

    case DOCS_UPLOADED_OR_EVERIFIED_SUCCESS: {
      return { ...state, isDocsUploadedOrEVerifiedSuccess: action.data };
    }

    case E_VERIFY_SUCCESS: {
      const data = action.data;
      let isDocsUploadedOrEVerifiedSuccess = state.isDocsUploadedOrEVerifiedSuccess;
      let isNewEVerifyObj = true;

      let eVerifyData = [...state.eVerifyData];
      if (eVerifyData && eVerifyData.length > 0) {
        eVerifyData.forEach((item) => {
          if (item.document_code === data[0].document_code) {
            item.is_everification_successful = data[0].is_everification_successful;
            isNewEVerifyObj = false;
          }
        });
      }
      if (isNewEVerifyObj) {
        eVerifyData = [...eVerifyData, ...data];
      }

      if (data[0].is_everification_successful && !isDocsUploadedOrEVerifiedSuccess) {
        isDocsUploadedOrEVerifiedSuccess = true;
        return { ...state, eVerifyData, isDocsUploadedOrEVerifiedSuccess };
      } else {
        return { ...state, eVerifyData };
      }
    }

    case INSERT_USER_DOCUMENT: {
      state.documentDetails.push(action.data);
      return { ...state };
    }

    case GET_UPLOAD_DOCUMENTS_CONFIG: {
      return { ...state, uploadDocConfig: action.data };
    }

    case UPDATE_UPLOAD_DOCUMENTS_CONFIG: {
      //update the store with the the document detail id for the resp document after E-Verification
      let uploadDocConfig = [...(state.uploadDocConfig || [])];

      if (uploadDocConfig.length > 0) {
        const data = action.data;
        for (let i = 0; i < uploadDocConfig.length; i++) {
          if (
            !uploadDocConfig[i].document_detail_id &&
            data.document_code &&
            data.document_code.indexOf(uploadDocConfig[i].document_code) > -1
          ) {
            if (data.document_detail_id)
              uploadDocConfig[i].document_detail_id = data.document_detail_id;
            uploadDocConfig[i].is_everification_successful = data.is_everification_successful;
            break;
          }
        }
      }

      uploadDocConfig = [...uploadDocConfig];
      return { ...state, uploadDocConfig };
    }

    case UPDATE_VISION_CHECK_COUNT: {
      let visionCheckCount = state.visionCheckCount;
      visionCheckCount++;
      return { ...state, visionCheckCount };
    }
    case EMP_TYPE_PASS: {
      return {
        ...state,
        empPass: action.data
      };
    }

    case UPLOAD_DOC_SUCCESS: {
      let findDocDetailsIndex = null;
      let documentDetails = state.documentDetails || [];
      const updatedData = action.data;
      let newDocDetails = [];
      if (updatedData && documentDetails && updatedData.length > 0 && documentDetails.length > 0) {
        updatedData.forEach((item) => {
          findDocDetailsIndex = documentDetails.findIndex(
            (subItem) => item.document_detail_id === subItem.document_detail_id
          );
          if (findDocDetailsIndex > -1) {
            documentDetails[findDocDetailsIndex] = { ...item };
            documentDetails = [...documentDetails, ...newDocDetails];
          } else {
            newDocDetails = [...newDocDetails, { ...item }];
            documentDetails = [...documentDetails, { ...item }];
          }
        });
      } else if (updatedData) {
        documentDetails = [...documentDetails, ...updatedData];
      }

      let isDocsUploadedOrEVerifiedSuccess = state.isDocsUploadedOrEVerifiedSuccess;

      if (!isDocsUploadedOrEVerifiedSuccess) {
        isDocsUploadedOrEVerifiedSuccess = true;
        return { ...state, documentDetails, isDocsUploadedOrEVerifiedSuccess };
      } else {
        return { ...state, documentDetails };
      }
    }

    case UPLOAD_PHOTO_SUCCESS: {
      const documentDetails = [...state.documentDetails, ...action.data];
      return { ...state, documentDetails };
    }

    case USER_DOCUMENTS_INFO: {
      const tempArray = [...action.data],
        ssnDetails = [],
        ssnDetailIndices = [];
      let isDocsUploadedOrEVerifiedSuccess = false,
        documentDetails = mergeObjectArray(state.documentDetails, tempArray, 'document_detail_id');

      documentDetails.forEach((item, index) => {
        if (item.document_code === 'SSN' || item.document_code === 'SOCIAL_INSURANCE_NUMBER') {
          ssnDetails.push(item);
          ssnDetailIndices.push(index);
        }
      });
      if (ssnDetailIndices.length > 0) {
        const successfulEverifyIndex = documentDetails.findIndex(
          (item) => item.is_everification_successful
        );
        if (successfulEverifyIndex) isDocsUploadedOrEVerifiedSuccess = true;
        ssnDetailIndices.forEach((item) => delete documentDetails[item]);
        documentDetails = documentDetails.filter((x) => x); //to remove undefined, null, 0 values from the array
      }

      if (ssnDetails.length > 0) state = { ...state, documentDetails, ssnDetails };
      else state = { ...state, documentDetails };

      if (!state.isDocsUploadedOrEVerifiedSuccess && isDocsUploadedOrEVerifiedSuccess)
        return { ...state, isDocsUploadedOrEVerifiedSuccess };
      else return { ...state };
    }
    case DISABLE_PERSONAL_DETAILS_FILEDS: {
      return { ...state, isDocsUploadedOrEVerifiedSuccess: true };
    }
    default:
      return state;
  }
}
